import BaseService from './base-service';

const GET_FIELDS_URL = '/api/v1/integration-fields/{{provider}}';

/**
 * Provides a facility to monitor the status of a specific running job.
 *
 * @example
 * import IntegrationsService from 'libs/services/integrations';
 * ...
 * const integrations = new IntegrationsService();
 */
export default class IntegrationsService extends BaseService {
    /**
     * Returns integration fields for given provider
     *
     * @param {'medpro'|'npi'|'salesforce'|'veeva'} provider
     * @returns {Promise<{fields:string[];searchable:string[]}>}
     */
    async getFieldsForProvider(provider) {
        const url = this.buildUrl(GET_FIELDS_URL, { provider });
        const { data } = await this.get(url);
        return data;
    }

    /**
     * Returns fields for all available integrations
     *
     * @returns {Promise<{[]: {fields:string[];searchable:string[]}}>}
     */
    async getAllFields() {
        const url = this.buildUrl(GET_FIELDS_URL, { provider: 'all' });
        const { data } = await this.get(url);
        return data;
    }
}
